const styles = theme => ({
  root: {
    display: 'flex',
    borderRadius: '16px',
    boxShadow:
      '0px 0px 2px 0px rgba(145, 158, 171, 0.12), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
    width: '100%',
    padding: '24px',
    minHeight: 'calc(80vh - 40px)',
    marginBottom: '16px',
    [`@media (max-width: 1280px)`]: {
      flexDirection: 'column',
    },
    [`@media (max-width: 1024px)`]: {
      padding: '16px',
    },
    [`@media (max-width: 768px)`]: {
      padding: '16px',
    },
  },
  content: {
    flex: 1,
    padding: '0 24px',
    overflow: 'auto',
    [`@media (max-width: 1280px)`]: {
      padding: '0px',
    },
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '200px',
  },
})

export default styles
